export const REQS_PAGE_LIST = [
	{ tab: 'total', text: 'LTL-перевозки', href: '/reqs/combined' },
	{ tab: 'total', text: 'FTL-перевозки', href: '/reqs/car' },
	{ tab: 'total', text: 'Развоз по территории', href: '/reqs/express' },
	{ tab: 'total', text: 'Авиа', href: '/reqs/avia' },
];
